<div class="page">
  <img class="scanner" src="./assets/img/scanner.png">
  <p class="error">404</p>
  <p>{{ 'page_not_found' | translate }}</p>
  <button class="button" (click)="location.back()">{{ 'go_back' | translate }}</button>
  <img class="img-fluid nimmsta-logo" src="./assets/img/logo.webp">
</div>
